import pallet from "./color-pallets/site-colors";

const colors = {
  primaryLight: pallet.primary[0],
  primaryLightBG: pallet.primary[1],
  primary: pallet.primary[4],
  primaryDark: pallet.primary[5],
  primaryTransparent: `${pallet.primary[4]}99`,
  modalBackdrop: `${pallet.neutrals[9]}90`,

  secondary: pallet.secondary[0],

  whiteTransparent: pallet.whiteTransparent[9],

  text: "#252525",
  textMuted: pallet.neutrals[5],
  textLight: pallet.neutrals[1],
  textHeading: pallet.primary[6],
  textNav: pallet.primary[4],

  light: pallet.neutrals[1],

  background: pallet.primary[0],
};

export default colors;

export const gradients = {
  primary: {
    backgroundImage: () => {
      return `linear-gradient(90deg, #004257 0%, #004D4B 79.17%);`;
    },
  },
};

export const colorPallet = { ...pallet };
